import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDrinksData } from "../api/marketOverviewApi";

export const fetchDrinks = createAsyncThunk(
  "drink/fetchDrinkData",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchDrinksData();

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  drinks: [],
  loading: false,
  error: null,
};

const drinkSlice = createSlice({
  name: "drink",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDrinks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDrinks.fulfilled, (state, action) => {
        state.loading = false;
        state.drinks = action.payload;
      })
      .addCase(fetchDrinks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default drinkSlice.reducer;
